<template>
  <v-layout justify-center>
    <v-dialog v-model="dialog_status"
      scrollable max-width="600px"
      @keydown.esc="close()">
      <v-card>

        <v-card-title class="card-title grey lighten-5">
          <div>{{ $t('reviews.document_details') }}</div>
          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn small icon v-on="on"
                  @click="close()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('reviews.close') }}</span>
            </v-tooltip>
          </div>
        </v-card-title>

        <v-card-text>
          <document-info></document-info>
        </v-card-text>

        <v-card-actions class="grey lighten-5"
          v-if="!!projects.length">
          <span class="action-title">
            In
          </span>
          <v-chip outlined v-for="(proj, i) in projects" :key=i
            class="action-chip"
            @click="selectDocument(proj.proj_id, dockey)">
            {{ proj.title }}
          </v-chip>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },

    dockey: {
      required: true,
    },
  },

  computed: {
    dialog_status: {
      get: function(value) {
        // console.log('get', value)
        return this.dialog
      },
      set: function(value) {
        // console.log('set', value)
        if (!value) { this.close() }
      },
    },

    ...mapGetters({
      projects: 'document/projects',
    }),
  },

  watch: {
    dockey: {
      async handler(val) {
        // console.log('dockey', val)
        if (!!val) {
          await this.reloadDocument()
        } else {
          this.close()
        }
      },
      immediate: true,
    },
  },

  methods: {
    close() {
      // console.log('close')
      this.$emit('update:dialog', false)
    },

    async reloadDocument() {
      try {
        this.$store.commit('document/setDocument', {})
      } finally {
        if (!!this.dockey) {
          await this.$store.dispatch('document/getDocument', this.dockey)
          await this.$store.dispatch('document/getProjects', this.dockey)
        }
      }
    },

    selectDocument(proj_id, doc_key) {
      this.$analytics.logEvent('click', { name: 'review_btn_selectDocument' })
      let to = { name: 'project', params: {id: proj_id}, query: { doc: doc_key} }
      this.$router.push(to)
    },
  },

}
</script>

<style scoped>
  .card-title {
    display: flex;
    justify-content: space-between;
  }

  .action-title {
    font-size: 14px;
    margin: 0 10px;
  }

  .action-chip {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/ReviewDetail.vue